import { useCallback } from 'react';

import { Label, Column, RadioInput } from 'components/Blocks';

import { CURRENCY_OPTIONS } from 'utils/constants';

import { StepComponentProps } from '../types';

export function ProjectCurrency({
  dispatch,
  state,
}: Pick<StepComponentProps, 'dispatch' | 'state'>): JSX.Element {
  const handleCurrencyChange = useCallback(
    (currency: string): void => {
      dispatch({
        currency,

        services: ({ services }) =>
          services.map(({ costs, ...rest }) => ({
            ...rest,
            costs: Object.fromEntries(
              Object.entries(costs).map(([country, serviceCosts]) => [
                country,
                serviceCosts.map((cost) =>
                  cost.type === 'CURRENCY'
                    ? {
                        ...cost,
                        currency,
                      }
                    : cost,
                ),
              ]),
            ),
          })),
      });
    },
    [dispatch],
  );

  return (
    <Column>
      <Label className="text-lg">Project&apos;s Currency</Label>

      <RadioInput
        name="currency"
        value={state.currency}
        onChangeDirect={handleCurrencyChange}
        containerClassName="w-full phone:grid phone:grid-cols-2"
        orientation="horizontal"
        addDot={false}
        className="w-full flex-1 rounded-lg border p-2 transition-colors hover:bg-hover"
        selectedClassName="border-primary text-primary hover:bg-transparent font-semibold"
        options={CURRENCY_OPTIONS}
      />
    </Column>
  );
}
